export const getEvaluationAppLink = (
  jobCode: string | number,
  hirist: boolean
) => {
  // Reuse the brands' configured OneLinks so Universal/App Links open the app,
  // and OneLink handles store fallback and deferred routing after installation.
  const url = new URL(
    hirist
      ? 'https://hirist.onelink.me/Z1Mi/nhaua4yj'
      : 'https://iimjobs.onelink.me/TyLF/4e9cio4c'
  );
  url.searchParams.set('deep_link_value', 'job_detail');
  url.searchParams.set('deep_link_sub1', String(jobCode));
  return url.toString();
};

// Desktop-only: clicking the QR (instead of scanning it) goes to the same
// destination the code encodes.
export const getScannerAppLink = (hirist: boolean) =>
  hirist
    ? 'https://hirist.onelink.me/Z1Mi/5aiz1rnb'
    : 'https://iimjobs.onelink.me/TyLF/hva44o2l';

// Existing Insights buttons use the same in-flow gate, including before login.
export const accessEvaluationInApp = (
  jobCode: string | number,
  hirist: boolean,
  isMobile: boolean
) => {
  if (isMobile) {
    window.location.assign(getEvaluationAppLink(jobCode, hirist));
    return;
  }
  const gate = Array.from(
    document.querySelectorAll<HTMLElement>('[data-evaluation-gate]')
  ).find(element => element.getClientRects().length > 0);
  gate?.scrollIntoView({block: 'center', behavior: 'smooth'});
};
